import createSelectors from './createSelectors';
import NotificationLog from '../models/NotificationLog';

const Select = createSelectors(NotificationLog, {});

export default Select;
